import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IBrandSubSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const BrandSubSection2 = styled.div<IBrandSubSectionProps>`
  .sub-brand-list {
    margin-bottom: 14px;
    background: transparent;

    .swiper {
      padding: 0 20px;

      .swiper-slide {
        width: auto !important;
      }
    }
  }

  .coupon-item {
    width: calc(100% - 40px);
    margin: 0 auto 12px;
  }

  .brand-banner {
    padding: 0 20px;
    margin-bottom: 12px;
    position: relative;

    .btn-more-small {
      position: absolute;
      top: 10px;
      right: 30px;
      border-radius: 14px;
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
      text-align: center;
      font-size: 11px;
      line-height: 130%;
      letter-spacing: -0.066px;
      padding: 6px 10px;
      gap: 6px;
    }

    .img {
      padding-bottom: 52.2388%;

      img {
        object-position: center 10%;
      }

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .brand-product-list {
    position: relative;
    text-align: center;

    .product-list {
      min-height: calc(${mixin.pxToVw('143')} + 68px);
    }

    .coming-soon {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.6);
      z-index: 1;
    }
  }

  .btn-more {
    background: transparent;
    margin-top: 32px;
  }

  &.bg-type-black {
    .btn-more {
      border-color: #555;

      .text {
        color: #fff;
      }
    }

    .brand-product-list .coming-soon {
      background: rgba(0, 0, 0, 0.6);
    }
  }

  ${({ $bgColor, $textColor }) =>
    $bgColor &&
    css`
      .brand-product-list .coming-soon {
        background: ${$bgColor};
        opacity: 0.6;
      }

      .btn-more .text {
        color: ${$textColor};
      }
    `}

  @media ${({ theme }) => theme.media.smMax} {
    .sub-brand-list {
      margin-bottom: ${mixin.pxToVw('14')};

      .swiper {
        padding: ${mixin.pxToVw('0 20')};
      }
    }

    .coupon-item {
      width: calc(100% - ${mixin.pxToVw('40')});
      margin: 0 auto ${mixin.pxToVw('12')};
    }

    .brand-banner {
      padding: ${mixin.pxToVw('0 20')};
      margin-bottom: ${mixin.pxToVw('12')};

      .btn-more-small {
        top: ${mixin.pxToVw('10')};
        right: ${mixin.pxToVw('30')};
        border-radius: ${mixin.pxToVw('14')};
        font-size: ${mixin.pxToVw('11')};
        padding: ${mixin.pxToVw('6 10')};
        gap: ${mixin.pxToVw('6')};
      }
    }

    .brand-product-list .product-list {
      min-height: ${mixin.pxToVw('211')};
    }

    /* 배너 없는 케이스의 하단 자세히보기 버튼 (.brand-product-list의 text-align: center로 정렬) */
    .product-list + .btn-more {
      margin-top: ${mixin.pxToVw('32')};
    }

    .btn-more {
      background: transparent;
      margin-top: ${mixin.pxToVw('32')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .sub-brand-list {
      margin-bottom: 0;

      .swiper {
        padding: 0;
      }
    }

    .coupon-item {
      width: 401px;
      margin: 0;
    }

    .brand-container {
      margin-top: 40px;
      ${mixin.flex({
        wrap: 'wrap',
        justify: 'space-between',
        align: 'flex-start',
      })};
      gap: 0 58px;

      .brand-right {
        width: 100%;
      }

      &:has(.brand-banner) .brand-right {
        width: 878px;
      }
    }

    .brand-banner {
      width: 375px;
      height: 485px;
      padding: 0;
      margin-bottom: 0;
      flex-shrink: 0;

      .img {
        padding-bottom: 129.33333%;

        img {
          object-position: center;
        }
      }
    }

    .brand-product-list {
      margin-top: 40px;

      .product-list {
        min-height: 359px;
      }
    }

    .btn-more {
      margin: 40px auto 0 auto;
      width: 430px;
    }
  }
`;
